import * as React from "react";

export default function Loader({text = "Chargement en cours ..."}: {text?: string}) {
    return <p className='text-center'>{text}</p>
}
